import { NgModule } from '@angular/core';
import { PolicyComponent } from './component/policy.component';
import { RouterModule, Routes } from '@angular/router';



const routes: Routes = [
  {
    path: '',
    title: 'policy',
    component: PolicyComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class PolicyRoutingModule { }
